export default "__VITE_ASSET__begU9Aw4__"